import gzBkImg from './bk-img/bk-img.module';
import gzImgSrc from './img-src/img-src.module';

export default angular.module('gazelle.components.printosImages', [
  gzBkImg,
  gzImgSrc,
])
  .name;
